
import { computed, defineComponent } from 'vue';

const listaVariaveis = [
  'TipoProducao',
  'CodigoEngenharia',
  'EngenhariaProducao',
  'DataCriacao',
  'DataInicio',
  'DataConclusao',
  'DataValidade',
  'NumeroInterno',
  'NumeroLote',
  'Status',
  'CustoTotal',
  'QuantidadeProduzir',
  'MateriaPrima',
  'QuantidadeMateriaPrima',
  'EstoqueMateriaPrima',
  'ProdutoAcabado',
  'QuantidadeProdutoAcabado',
  'EstoqueProdutoAcabado',
  'Unidade',
  'Participacao',
  'Observacao',
];

export default defineComponent({
  name: 'SelecionarCamposRelatorioPCP',
  props: {
    campos: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:campos', 'change'],
  setup(props, { emit }) {
    // Variável de controle do drag
    let dragSource: number | null = null;

    // 1. Transforma a lista de strings em objetos { value, label } para o AntD
    const opcoesDisponiveis = listaVariaveis.map((item) => ({
      value: item,
      label: item,
    }));

    // 2. Lista de campos selecionados (mantém a ordem)
    const camposSelecionados = computed({
      get: () => {
        if (!props.campos) return [];
        return props.campos.split(',').map((s) => s.trim()).filter(Boolean);
      },
      set: (valores: string[]) => {
        const stringFinal = valores.join(', ');
        emit('update:campos', stringFinal);
        emit('change', stringFinal);
      },
    });

    // 3. Computed para o select do AntD
    const novosCampos = computed({
      get: () => camposSelecionados.value,
      set: (valores: string[]) => {
        camposSelecionados.value = valores;
      },
    });

    // 4. Função de filtro para a busca (case insensitive)
    const filtrarOpcoes = (input: string, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    // 5. Funções de drag and drop
    const iniciarDrag = (dragEvent: DragEvent, index: number) => {
      const dt = dragEvent.dataTransfer;
      dragSource = index;
      if (dt) {
        dt.effectAllowed = 'move';
        dt.setData('text/html', '');
      }
      // Aplica estilo ao elemento sendo arrastado
      const elem = dragEvent.target as HTMLElement;
      if (elem) {
        elem.classList.add('ss-dragging');
      }
    };

    const dragoverCampo = (dragEvent: DragEvent) => {
      const dt = dragEvent.dataTransfer;
      if (dt) {
        dt.dropEffect = 'move';
      }
      // Aplica estilo visual do drop target
      const target = (dragEvent.currentTarget as HTMLElement);
      if (target) {
        target.classList.add('ss-drag-over');
      }
    };

    const soltarCampo = (dragEvent: DragEvent, dropIndex: number) => {
      const evt = dragEvent;
      evt.preventDefault();

      if (dragSource === null || dragSource === dropIndex) {
        dragSource = null;
        return;
      }

      // Copia o array de campos
      const novaOrdem = [...camposSelecionados.value];

      // Remove o item do índice original
      const [campo] = novaOrdem.splice(dragSource, 1);

      // Insere o item no novo índice
      novaOrdem.splice(dropIndex, 0, campo);

      // Atualiza a lista
      camposSelecionados.value = novaOrdem;

      // Remove estilo visual
      const target = (dragEvent.currentTarget as HTMLElement);
      if (target) {
        target.classList.remove('ss-drag-over');
      }

      dragSource = null;
    };

    const finalizarDrag = (dragEvent: DragEvent) => {
      // Remove estilo do elemento sendo arrastado
      const elem = dragEvent.target as HTMLElement;
      if (elem) {
        elem.classList.remove('ss-dragging');
      }

      // Remove estilo de todos os campos
      const campos = document.querySelectorAll('.ss-campo-item');
      campos.forEach((el: Element) => {
        el.classList.remove('ss-drag-over');
      });

      dragSource = null;
    };

    const removerCampo = (index: number) => {
      const novaOrdem = [...camposSelecionados.value];
      novaOrdem.splice(index, 1);
      camposSelecionados.value = novaOrdem;
    };

    return {
      opcoesDisponiveis,
      novosCampos,
      camposSelecionados,
      filtrarOpcoes,
      iniciarDrag,
      dragoverCampo,
      soltarCampo,
      finalizarDrag,
      removerCampo,
    };
  },
});
